import type { RankingData } from '../data-engineering/exercises';

export const linkedInRankingData: Record<number, RankingData> = {
  0: {
    question: 'Ordená estas acciones de LinkedIn de MÁS impacto a MENOS impacto para conseguir trabajo.',
    options: [
      { id: 1, text: 'Optimizar tu perfil con palabras clave que buscan los reclutadores' },
      { id: 2, text: 'Publicar contenido técnico relevante de forma constante' },
      { id: 3, text: 'Conectar con reclutadores y profesionales de tu industria' },
      { id: 4, text: 'Agregar certificaciones y cursos a tu perfil' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Sin un perfil optimizado, todo lo demás pierde efecto. Los reclutadores buscan por palabras clave — si no aparecés, no existís. El contenido genera visibilidad orgánica. El networking amplifica tu alcance. Las certificaciones son un plus pero rara vez son lo que decide una contratación.',
  },
  1: {
    question: 'Un reclutador busca "Data Engineer". Ordená estos perfiles de MÁS probable a MENOS probable de aparecer en su búsqueda.',
    options: [
      { id: 1, text: 'Headline: "Data Engineer | Databricks | Spark | AWS" — perfil completo y activo' },
      { id: 2, text: 'Headline: "Data Engineer" — perfil con experiencia pero sin keywords adicionales' },
      { id: 3, text: 'Headline: "Ingeniero de Datos | Apasionado por la tecnología"' },
      { id: 4, text: 'Headline: "Profesional IT buscando nuevas oportunidades"' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'LinkedIn prioriza perfiles con keywords exactas en el headline, completitud del perfil y actividad reciente. "Data Engineer" en español ("Ingeniero de Datos") no aparece cuando buscan en inglés. Un headline genérico sin el rol específico es prácticamente invisible.',
  },
  2: {
    question: 'Ordená estos elementos del algoritmo de LinkedIn de MÁS peso a MENOS peso para el posicionamiento en búsquedas.',
    options: [
      { id: 1, text: 'Headline (título profesional)' },
      { id: 2, text: 'Sección About con keywords estratégicas' },
      { id: 3, text: 'Experiencia laboral con descripciones detalladas' },
      { id: 4, text: 'Skills endorsados por conexiones' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El headline tiene el mayor peso en el algoritmo de búsqueda. El About es lo segundo que LinkedIn indexa. La experiencia valida las keywords. Los endorsements de skills ayudan pero tienen menor peso algorítmico.',
  },
  3: {
    question: 'Ordená estas alertas/configuraciones de LinkedIn de MÁS útil a MENOS útil para encontrar trabajo.',
    options: [
      { id: 1, text: 'Alertas de empleo con keywords y filtros específicos de tu rol' },
      { id: 2, text: '"Open to Work" visible solo para reclutadores (no público)' },
      { id: 3, text: 'Seguir empresas target y activar notificaciones de vacantes' },
      { id: 4, text: 'El banner verde "Open to Work" visible para todos' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Las alertas específicas te avisan primero cuando hay vacantes que matchean. "Open to Work" para reclutadores es efectivo sin parecer desesperado. Seguir empresas te da info temprana. El banner verde público puede generar un sesgo negativo en algunos reclutadores.',
  },
  4: {
    question: 'Ordená estos factores de MÁS importante a MENOS importante para competir en el mercado laboral tech.',
    options: [
      { id: 1, text: 'Proyectos reales demostrables (portfolio)' },
      { id: 2, text: 'Capacidad de comunicar tu valor en entrevistas' },
      { id: 3, text: 'Título universitario en sistemas o ingeniería' },
      { id: 4, text: 'Cantidad de certificaciones online' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Lo que más pesa en tech es lo que podés demostrar que hiciste. Comunicar tu valor te diferencia en entrevistas. El título importa en algunas empresas pero cada vez menos. Las certificaciones solas sin experiencia práctica tienen bajo impacto.',
  },
  5: {
    question: 'Ordená estas estrategias de networking de MÁS efectiva a MENOS efectiva.',
    options: [
      { id: 1, text: 'Comentar con valor en posts de personas de tu industria' },
      { id: 2, text: 'Enviar mensajes personalizados a reclutadores de empresas target' },
      { id: 3, text: 'Publicar tu propio contenido técnico regularmente' },
      { id: 4, text: 'Agregar conexiones masivamente sin mensaje personalizado' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Comentar con valor te hace visible ante la audiencia de otros sin crear contenido. Mensajes personalizados funcionan si son relevantes. Publicar contenido propio construye autoridad a largo plazo. Las conexiones masivas sin contexto tienen tasa de aceptación bajísima.',
  },
  6: {
    question: 'Ordená estos elementos del headline de MÁS importante a MENOS importante.',
    options: [
      { id: 1, text: 'Tu rol actual o deseado con keywords exactas ("Data Engineer")' },
      { id: 2, text: 'Tecnologías que dominás (Spark, Databricks, AWS)' },
      { id: 3, text: 'Empresa actual o tipo de industria' },
      { id: 4, text: 'Frase motivacional o personal branding creativo' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El rol con keywords exactas es lo que buscan los reclutadores. Las tecnologías filtran matches relevantes. La empresa da contexto. Las frases motivacionales no aparecen en búsquedas y ocupan espacio valioso.',
  },
  7: {
    question: 'Ordená estos títulos de headline de MÁS efectivo a MENOS efectivo para un perfil de Data Engineering.',
    options: [
      { id: 1, text: 'Sr Data Engineer | Databricks · Spark · AWS | Ex-MercadoLibre' },
      { id: 2, text: 'Data Engineer | Python, SQL, ETL Pipelines' },
      { id: 3, text: 'Ingeniero de Datos | Apasionado por los datos y la tecnología' },
      { id: 4, text: 'Buscando oportunidades en el mundo de los datos' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El primero tiene keywords exactas, tecnologías de demanda, nivel de seniority y una marca reconocible. El segundo es bueno pero genérico. El tercero usa español (los reclutadores buscan en inglés) y una frase vacía. El cuarto no dice qué hacés ni qué sabés.',
  },
  8: {
    question: 'Ordená estos elementos de MÁS importante a MENOS importante para las keywords de tu perfil.',
    options: [
      { id: 1, text: 'Keywords que los reclutadores realmente buscan (ej: "Data Engineer", "Spark")' },
      { id: 2, text: 'Keywords en tu headline y About (mayor peso algorítmico)' },
      { id: 3, text: 'Keywords en la descripción de cada experiencia laboral' },
      { id: 4, text: 'Keywords en la sección de Skills' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Primero hay que saber QUÉ buscan (investigar ofertas reales). Después ubicarlas donde LinkedIn les da más peso (headline y About). La experiencia las valida con contexto. Los Skills son lo último que LinkedIn indexa.',
  },
  9: {
    question: 'Ordená estos tips de foto de perfil de MÁS impacto a MENOS impacto.',
    options: [
      { id: 1, text: 'Foto nítida, profesional, con buena iluminación y fondo limpio' },
      { id: 2, text: 'Sonrisa natural que transmita cercanía y confianza' },
      { id: 3, text: 'Vestimenta acorde al rol (no necesariamente traje)' },
      { id: 4, text: 'Fondo de color sólido o ligeramente desenfocado' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'La calidad de la foto es lo primero que impacta — fotos borrosas o recortadas generan desconfianza. La sonrisa genera conexión (los perfiles con sonrisa reciben 14% más vistas). La vestimenta da contexto profesional. El fondo es un detalle que suma pero no define.',
  },
  10: {
    question: 'Ordená estos principios de claridad en perfiles de MÁS importante a MENOS importante.',
    options: [
      { id: 1, text: 'Decir exactamente qué hacés y para quién en una oración' },
      { id: 2, text: 'Eliminar buzzwords vacíos ("apasionado", "proactivo", "líder")' },
      { id: 3, text: 'Usar métricas y resultados concretos en vez de responsabilidades' },
      { id: 4, text: 'Mantener párrafos cortos (3-4 líneas máximo)' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'La claridad empieza por decir qué hacés sin ambigüedad. Los buzzwords ocupan espacio y no dicen nada. Las métricas demuestran impacto real. El formato corto mejora la lectura pero el contenido tiene que ser bueno primero.',
  },
  11: {
    question: 'Ordená estos títulos ambiguos de PEOR a MEJOR para un perfil de LinkedIn.',
    options: [
      { id: 1, text: '"Haciendo cosas increíbles con datos"' },
      { id: 2, text: '"Profesional IT multidisciplinario"' },
      { id: 3, text: '"Analista de Datos en transición a Data Engineering"' },
      { id: 4, text: '"Data Engineer | Python · SQL · Spark"' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El primero es completamente vacío — no dice nada. "Multidisciplinario" tampoco dice qué hacés. "En transición" al menos es honesto y tiene keywords. El último es claro, indexable y directo.',
  },
  12: {
    question: 'Ordená estas habilidades de MÁS importante a MENOS importante para destacar en un perfil de Data Engineering.',
    options: [
      { id: 1, text: 'SQL, Python, Spark (hard skills del día a día)' },
      { id: 2, text: 'Databricks, AWS, Azure (plataformas de demanda)' },
      { id: 3, text: 'Comunicación técnica y trabajo en equipo' },
      { id: 4, text: 'Excel avanzado y PowerPoint' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'SQL y Python son innegociables para DE. Las plataformas cloud son el diferenciador actual. Las soft skills importan pero se demuestran, no se listan. Excel/PowerPoint son skills de otro rol — ocupan espacio valioso.',
  },
  13: {
    question: 'Ordená estos elementos del About de MÁS importante a MENOS importante.',
    options: [
      { id: 1, text: 'Primera oración: qué hacés y qué problema resolvés' },
      { id: 2, text: 'Logros con números y métricas reales' },
      { id: 3, text: 'Stack tecnológico y herramientas que dominás' },
      { id: 4, text: 'Hobbies o intereses personales' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'LinkedIn muestra solo las primeras 2 líneas del About antes de "ver más". Si no enganchás ahí, nadie lee el resto. Los logros validan tu capacidad. El stack da contexto técnico. Los hobbies pueden humanizar pero van al final.',
  },
  14: {
    question: 'Ordená estos enfoques para contar tu historia profesional de MÁS efectivo a MENOS efectivo.',
    options: [
      { id: 1, text: 'Problema que resolviste → Cómo lo hiciste → Resultado medible' },
      { id: 2, text: 'Contexto breve → Acción específica → Impacto en el negocio' },
      { id: 3, text: 'Lista de responsabilidades del puesto' },
      { id: 4, text: 'Descripción genérica copiada del job description' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El formato Problema → Acción → Resultado (PAR) es el más persuasivo. El CAR (Contexto-Acción-Resultado) es igual de bueno. Las listas de responsabilidades no te diferencian. Copiar el job description es lo peor — todos los que tuvieron ese puesto dicen lo mismo.',
  },
  15: {
    question: 'Ordená estos consejos para comunicar experiencia transferible de MÁS efectivo a MENOS efectivo.',
    options: [
      { id: 1, text: 'Traducir logros de tu rol anterior al lenguaje del rol nuevo' },
      { id: 2, text: 'Mostrar proyectos personales que demuestren las nuevas skills' },
      { id: 3, text: 'Mencionar cursos y certificaciones del nuevo campo' },
      { id: 4, text: 'Explicar que estás "en transición" y "aprendiendo"' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Traducir logros muestra que ya tenés capacidades valiosas. Los proyectos demuestran que podés hacer el trabajo. Los cursos muestran compromiso. Decir "estoy aprendiendo" te posiciona como junior cuando podrías posicionarte como alguien que ya aporta valor.',
  },
  16: {
    question: 'Ordená estas soft skills de MÁS valorada a MENOS valorada por empresas tech.',
    options: [
      { id: 1, text: 'Comunicar conceptos técnicos de forma clara a no-técnicos' },
      { id: 2, text: 'Resolver problemas de forma autónoma buscando soluciones' },
      { id: 3, text: 'Adaptarse rápido a cambios de prioridades y tecnologías' },
      { id: 4, text: 'Organizar eventos de team building' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'La comunicación técnica es la soft skill #1 en data — si no podés explicar tu pipeline, nadie confía en él. La autonomía es crucial en equipos remotos. La adaptabilidad es necesaria en un campo que cambia cada 6 meses. El team building es lindo pero no es un diferenciador en entrevistas.',
  },
  17: {
    question: 'Ordená estos perfiles de LinkedIn de MÁS efectivo a MENOS efectivo como benchmark para un Data Engineer.',
    options: [
      { id: 1, text: 'Data Engineer en tu región con el puesto que querés, perfil completo y activo' },
      { id: 2, text: 'Data Engineer en una empresa top (FAANG) con perfil detallado' },
      { id: 3, text: 'Influencer de datos con muchos seguidores pero sin rol de DE activo' },
      { id: 4, text: 'Perfil con 500+ conexiones pero sin contenido ni actividad' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El mejor benchmark es alguien alcanzable con el puesto que querés en tu mercado. Los perfiles FAANG son aspiracionales pero a veces no aplican a tu realidad. Los influencers tienen engagement pero no necesariamente un perfil optimizado para búsqueda. Un perfil con muchas conexiones sin actividad no dice nada.',
  },
  18: {
    question: 'Ordená estos pasos de un plan de acción de LinkedIn de PRIMERO a ÚLTIMO.',
    options: [
      { id: 1, text: 'Optimizar headline, About y experiencia con keywords' },
      { id: 2, text: 'Subir foto profesional y banner relevante' },
      { id: 3, text: 'Empezar a comentar y publicar contenido 2-3 veces por semana' },
      { id: 4, text: 'Aplicar a empleos y contactar reclutadores directamente' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'Primero optimizá el perfil — es tu landing page. La foto y banner son lo visual que complementa. El contenido genera visibilidad orgánica. Aplicar y contactar reclutadores es el último paso porque ahora tu perfil está listo para que te evalúen.',
  },
  19: {
    question: 'Ordená estos errores de LinkedIn de MÁS grave a MENOS grave.',
    options: [
      { id: 1, text: 'Headline que no dice qué hacés ("Buscando oportunidades")' },
      { id: 2, text: 'About vacío o con un solo párrafo genérico' },
      { id: 3, text: 'Experiencia sin resultados ni métricas' },
      { id: 4, text: 'No tener banner personalizado' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'El headline es lo primero que ven en búsquedas — si no funciona, nunca hacen click. El About vacío es una oportunidad desperdiciada de convencer. La experiencia sin métricas no diferencia. El banner es estético — lindo pero no crítico.',
  },
  20: {
    question: 'Ordená estas diferencias LinkedIn vs CV de MÁS relevante a MENOS relevante.',
    options: [
      { id: 1, text: 'LinkedIn es buscable por reclutadores 24/7 — el CV solo cuando lo enviás' },
      { id: 2, text: 'LinkedIn permite mostrar proyectos, contenido y recomendaciones' },
      { id: 3, text: 'LinkedIn se actualiza una vez y sirve para todo — el CV se adapta por empresa' },
      { id: 4, text: 'LinkedIn tiene foto y banner — el CV generalmente no' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'La ventaja #1 de LinkedIn es la búsqueda activa de reclutadores — te encuentran sin que apliques. La capacidad de mostrar trabajo real es lo segundo más poderoso. La universalidad del perfil ahorra tiempo. La foto es un detalle menor comparado con el resto.',
  },
  21: {
    question: 'Ordená estas preguntas frecuentes de LinkedIn de MÁS importante de resolver a MENOS.',
    options: [
      { id: 1, text: '¿Cómo hago para que me encuentren los reclutadores?' },
      { id: 2, text: '¿Qué pongo en el headline si estoy en transición de carrera?' },
      { id: 3, text: '¿Debo poner "Open to Work"? ¿Visible para todos o solo reclutadores?' },
      { id: 4, text: '¿Cuántas conexiones necesito para que mi perfil sea relevante?' },
    ],
    correctOrder: [1, 2, 3, 4],
    explanation: 'La visibilidad ante reclutadores es lo que genera oportunidades. El headline en transición es la segunda duda más común. Open to Work es una decisión táctica. La cantidad de conexiones importa menos de lo que la gente cree — es calidad > cantidad.',
  },
};
